export default __webpack_public_path__ + "static/media/header-blumen.b29c9370.webp";